import { useState } from "react";
import { Save, Crown } from "lucide-react";
import api, { apiErr } from "../lib/api";
import { SectionCard, Pill, Stamp } from "./kit";
import { Button } from "./ui/button";
import { Field, Input } from "./form";
import { useAuth } from "../context/AuthContext";
import { titleCase } from "../lib/constants";
import { toast } from "sonner";

export default function MyAccount() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ name: user?.name || "", email: user?.email || "", current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async () => {
    if (f.new_password && f.new_password !== f.confirm) { toast.error("New passwords do not match"); return; }
    setBusy(true);
    try {
      const payload = { name: f.name, email: f.email };
      if (f.new_password) payload.new_password = f.new_password;
      if (f.current_password) payload.current_password = f.current_password;
      const { data } = await api.put("/auth/profile", payload);
      localStorage.setItem("gas_token", data.access_token);
      setUser(data.user);
      setF({ ...f, current_password: "", new_password: "", confirm: "" });
      toast.success("Your account was updated");
    } catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };

  const changingSecret = f.email !== user?.email || !!f.new_password;
  return (
    <SectionCard title="My Account" testid="my-account-card"
      action={<Pill className={user?.role === "master" ? "bg-amber-50 text-amber-700 border-amber-200" : ""}>{user?.role === "master" && <Crown className="w-3 h-3 mr-1" />}{titleCase(user?.role || "")}</Pill>}>
      <p className="text-sm text-slate-500 mb-4">Update your display name, sign-in email, or password. Your current password is required to change the email or password.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field label="Display name"><Input value={f.name} onChange={set("name")} data-testid="account-name" /></Field>
        <Field label="Sign-in email"><Input type="email" value={f.email} onChange={set("email")} data-testid="account-email" /></Field>
        <Field label="Current password" required={changingSecret}><Input type="password" value={f.current_password} onChange={set("current_password")} autoComplete="current-password" data-testid="account-current-password" /></Field>
        <div />
        <Field label="New password"><Input type="password" value={f.new_password} onChange={set("new_password")} autoComplete="new-password" placeholder="Leave blank to keep" data-testid="account-new-password" /></Field>
        <Field label="Confirm new password"><Input type="password" value={f.confirm} onChange={set("confirm")} autoComplete="new-password" data-testid="account-confirm-password" /></Field>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3 mt-4">
        <div className="flex flex-col gap-1">
          <Stamp prefix="Account created" at={user?.created_at} by={user?.created_by_name} testid="account-created-stamp" />
          {user?.last_login_at && <Stamp prefix="Last sign-in" at={user.last_login_at} testid="account-last-login" />}
        </div>
        <Button className="bg-navy-800 text-white" onClick={save} disabled={busy} data-testid="save-account-btn"><Save className="w-4 h-4 mr-1.5" />Save changes</Button>
      </div>
    </SectionCard>
  );
}
